// client/src/components/itensVenda/ItemVendaRow.js - VERSÃO CORRIGIDA
import React from 'react';
import { MoreVertical, EyeOff, CheckCircle, XCircle } from 'lucide-react';
import PropTypes from 'prop-types';

const ItemVendaRow = ({ item, onOpenActions, loading = false }) => {

    const safeItem = {
        _id: item._id || item.id || 'unknown-id',
        nome: item.nome || 'Sem nome',
        categoria: item.categoria || { nome: 'Sem categoria' },
        sku: item.sku || '-',
        unidadesDetalhes: item.unidadesDetalhes || [],
        ativo: item.ativo !== undefined ? item.ativo : true,
        visivelParaCliente: item.visivelParaCliente !== undefined ? item.visivelParaCliente : true,
        controlaEstoque: item.controlaEstoque,
        imagens: item.imagens || [],
        imagensDaGaleria: item.imagensDaGaleria || [],
        imagemPrincipal: item.imagemPrincipal || null,
        tags: Array.isArray(item.tags) ? item.tags : []
    };

    const categoriaNome = typeof safeItem.categoria === 'string' 
        ? safeItem.categoria 
        : safeItem.categoria?.nome || 'Sem categoria';

    return (
        <tr className={`table-row ${loading ? 'opacity-50' : ''}`}>
            <td className="table-cell">
                <div className="flex items-center">
                    {!safeItem.ativo && (
                        <EyeOff size={16} className="text-gray-400 mr-2" title="Inativo" />
                    )}
                    {!safeItem.visivelParaCliente && (
                        <EyeOff size={16} className="text-orange-400 mr-2" title="Oculto para clientes" />
                    )}
                    <span className="font-medium">{safeItem.nome}</span>
                </div>
            </td>
            <td className="table-cell">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                    {categoriaNome}
                </span>
            </td>
            <td className="table-cell">
                <code className="text-xs bg-gray-100 px-2 py-1 rounded">
                    {safeItem.sku}
                </code>
            </td>
            <td className="table-cell">
                <div className="flex items-center justify-center space-x-2">
                    {safeItem.ativo ? (
                        <>
                            <CheckCircle size={18} className="text-green-600" />
                            <span className="text-green-600 font-medium">Ativo</span>
                        </>
                    ) : (
                        <>
                            <XCircle size={18} className="text-red-600" />
                            <span className="text-red-600 font-medium">Inativo</span>
                        </>
                    )}
                </div>
            </td>
            <td className="text-right">
                <button
                    onClick={() => onOpenActions(safeItem)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading || !safeItem._id || safeItem._id === 'unknown-id'}
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

ItemVendaRow.propTypes = {
    item: PropTypes.shape({
        _id: PropTypes.string,
        id: PropTypes.string,
        nome: PropTypes.string,
        categoria: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                nome: PropTypes.string
            })
        ]),
        sku: PropTypes.string,
        unidadesDetalhes: PropTypes.array,
        ativo: PropTypes.bool,
        visivelParaCliente: PropTypes.bool,
        controlaEstoque: PropTypes.bool,
        imagens: PropTypes.array,
        imagensDaGaleria: PropTypes.array,
        imagemPrincipal: PropTypes.shape({
            refId: PropTypes.string,
            url: PropTypes.string
        }),
        tags: PropTypes.arrayOf(PropTypes.string)
    }).isRequired,
    onOpenActions: PropTypes.func,
    loading: PropTypes.bool
};

export default ItemVendaRow;